import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import TargetAssignmentActions from "../../../../reducers/modules/sales/target-assignment/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/target-assignment";

export default class TargetAssignmentMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.create());
    };
  }

  static createTarget() {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.createTarget());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.update());
      TargetAssignmentMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.process());
      TargetAssignmentMiddleware.showlist(dispatch, params);
    };
  }
  static listAssign(params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.process());
      TargetAssignmentMiddleware.showlistAssign(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.view());
      TargetAssignmentMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.submit());
      TargetAssignmentMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.submit());
      TargetAssignmentMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.beforePrint());
      TargetAssignmentMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(TargetAssignmentActions.delete());
      TargetAssignmentMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      TargetAssignmentMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      TargetAssignmentMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-cashbank-book",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.list(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlistAssign(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url+'/assign',
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.listAssign(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }
  
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-sales-order",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }
  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.print(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(TargetAssignmentActions.view(response.data.result));
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TargetAssignmentActions.process(),
            TargetAssignmentMiddleware.showlist(dispatch, params)
          );
          TargetAssignmentMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TargetAssignmentActions.process(),
            TargetAssignmentMiddleware.showlist(dispatch, search)
          );
          dispatch(TargetAssignmentActions.success());
          TargetAssignmentMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${TargetAssignmentMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            TargetAssignmentActions.process(),
            TargetAssignmentMiddleware.showlist(dispatch, search)
          );
          dispatch(TargetAssignmentActions.success());
          TargetAssignmentMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        TargetAssignmentMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(TargetAssignmentActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(TargetAssignmentActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
